import { render, staticRenderFns } from "./Users_view.vue?vue&type=template&id=5350b3ed&scoped=true&"
import script from "./Users_view.vue?vue&type=script&lang=js&"
export * from "./Users_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5350b3ed",
  null
  
)

export default component.exports